import React from 'react';

const PersonIcon = ({ width = 18, height = 18, color = 'white', ...rest }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      ref={ref}
      {...rest}>
      <g clip-path="url(#clip0_19800_85702)">
        <path
          d="M11.3086 5.5C11.3086 4.91984 11.0781 4.36344 10.6679 3.9532C10.2577 3.54297 9.70125 3.3125 9.12109 3.3125C8.54093 3.3125 7.98453 3.54297 7.5743 3.9532C7.16406 4.36344 6.93359 4.91984 6.93359 5.5C6.93359 6.08016 7.16406 6.63656 7.5743 7.0468C7.98453 7.45703 8.54093 7.6875 9.12109 7.6875C9.70125 7.6875 10.2577 7.45703 10.6679 7.0468C11.0781 6.63656 11.3086 6.08016 11.3086 5.5ZM5.62109 5.5C5.62109 4.57174 5.98984 3.6815 6.64622 3.02513C7.3026 2.36875 8.19284 2 9.12109 2C10.0494 2 10.9396 2.36875 11.596 3.02513C12.2523 3.6815 12.6211 4.57174 12.6211 5.5C12.6211 6.42826 12.2523 7.3185 11.596 7.97487C10.9396 8.63125 10.0494 9 9.12109 9C8.19284 9 7.3026 8.63125 6.64622 7.97487C5.98984 7.3185 5.62109 6.42826 5.62109 5.5ZM4.34414 14.6875H13.898C13.6547 12.9566 12.1672 11.625 10.3707 11.625H7.87148C6.075 11.625 4.5875 12.9566 4.34414 14.6875ZM2.99609 15.1879C2.99609 12.4945 5.17813 10.3125 7.87148 10.3125H10.3707C13.0641 10.3125 15.2461 12.4945 15.2461 15.1879C15.2461 15.6363 14.8824 16 14.434 16H3.8082C3.35977 16 2.99609 15.6363 2.99609 15.1879Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19800_85702">
          <rect width="12.25" height="14" fill={color} transform="translate(2.99609 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.forwardRef(PersonIcon);
